module.exports = __webpack_public_path__ + "img/logo.f29608a6.png";